import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import PastIcon from '@material-ui/icons/ChevronRight'
import TimeSliderActions from '../redux/timeSliderRedux'
import Tooltip from '@material-ui/core/Tooltip'
import PaperIcon from './PaperIcon'
import isEmptyObject from '../utility/isEmptyObject'

const styles = theme => ({
  container: {
    paddingTop: 10,
    paddingBottom: 10
  },
  button: {},
  empty: {},
  icon: {
    transform: 'rotate(90deg)'
  }
})

const ButtonPastDatetime = props => {
  const { actions, classes, marks, hidden } = props

  if (hidden) {
    return (
      null
    )
  }

  if (!marks || (marks && isEmptyObject(marks))) {
    return <div className={classes.empty} />
  }

  if (Object.keys(marks).length < 2) {
    return <div className={classes.empty} />
  }

  return (
    <div className={classes.container}>
      <PaperIcon>
        <Tooltip
          placement='bottom-start'
          id='tooltip-previous-date'
          title='previous date'
        >
          <IconButton
            color='primary'
            className={classes.icon}
            onClick={actions.timeSliderValueDecremented}
          >
            <PastIcon />
          </IconButton>
        </Tooltip>
      </PaperIcon>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    marks: state.timeSlider.marks || {}
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      timeSliderValueDecremented: () =>
        dispatch(TimeSliderActions.timeSliderValueDecremented()),
      timeSliderValueIncremented: () =>
        dispatch(TimeSliderActions.timeSliderValueIncremented())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ButtonPastDatetime)
)



// WEBPACK FOOTER //
// ./src/components/ButtonPastDatetime.js